


















import Vue from 'vue'

export default Vue.extend({
  props: {
    icons: {
      type: Object,
      default: () => ({
        close: {
          img: require('@/components/VueBeautifulChat/assets/close-icon-big.png'),
          name: 'default'
        }
      })
    },
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    disableUserListToggle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleUserList (): void {
      this.inUserList = !this.inUserList
      this.$emit('userList', this.inUserList)
    }
  },
  data: () => ({
    inUserList: false
  })
})
